import React, { Component } from "react";
import firebase from 'firebase';

class Add extends Component {
  constructor () {
    super();
    this.handleAddBook = this.handleAddBook.bind(this);
    this.state = {
      notification: null,
      timeout: null
    }
  }
  handleAddBook (e) {
    e.preventDefault();
    if (this.refs.title.value === "" || this.refs.author.value === "") {
      this.setState({
        notification: 'Title and Author are required'
      });
      return;
    }

    const self = this;
    function resetFormFields() {
      self.refs.author.value = "";
      self.refs.class.value = "";
      self.refs.date.value = "";
      self.refs.keywords.value = "";
      self.refs.ref.value = "";
      self.refs.title.value = "";
      self.refs.pages.value = "";
    }
    function addNotification(notification) {
      self.setState({
        notification
      });
      self.timeout = setTimeout(function () {
        self.setState({
          notification: null
        });
      }, 3000)
    }
    const newBookRef = firebase.database().ref('books').push();

    let keywordArray = this.refs.keywords.value !== "" ? this.refs.keywords.value.split(',').map(function(keyword) {
      return keyword.trim();
    }) : 0;
    let book = {
      Author: this.refs.author.value,
      Class: this.refs.class.value,
      Date: this.refs.date.value,
      Keywords: keywordArray,
      Ref: this.refs.ref.value,
      Title: this.refs.title.value,
      pages: this.refs.pages.value
    }
    newBookRef.set(book).then(() => {
      console.log('Book Added');
      resetFormFields();
      addNotification('Added to DB');
    }).catch(err => {
      console.log('Database Write Failed');
      addNotification('There was a problem adding the Book');
    })
  }

  componentWillUnmount () {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  render () {
    let notification = this.state.notification ? (
      <div className="notification toast alert alert-info">
        {this.state.notification}
      </div>
    ) : null;

    return (
      <div className="add-book col-md-6 col-md-offset-3">
        <h1>Add Book</h1>
        <form className="form clearfix" onSubmit={this.handleAddBook}>
          <div className="form-group">
            <label>Title: </label>
            <input type="text" className="form-control" ref="title"  />
          </div>
          <div className="form-group">
            <label>Author: </label>
            <input type="text" className="form-control" ref="author"/>
          </div>
          <div className="row">
            <div className="form-group col-xs-6 col-md-4">
              <label>Date: </label>
              <input type="text" className="form-control" ref="date"  />
            </div>
            <div className="form-group col-xs-6 col-md-4">
              <label>Ref: </label>
              <input type="text" className="form-control" ref="ref"  />
            </div>
            <div className="form-group col-xs-6 col-md-4">
              <label>Class: </label>
              <input type="text" className="form-control" ref="class" />
            </div>
            <div className="form-group col-xs-6 col-md-4">
              <label>Pages: </label>
              <input type="text" className="form-control" ref="pages" />
            </div>
          </div>
          <div className="row">
            <div className="form-group col-xs-12">
              <label>Keywords: </label>
              <input type="text" className="form-control" ref="keywords"/>
              <span className="help-block">comma separated list</span>
            </div>
          </div>
          <div className="modal-footer">
            {notification}
            <input type="submit" className="btn btn-warning" value="Add Book" />
          </div>
        </form>
      </div>
    );
  }
}

export default Add;



/** WEBPACK FOOTER **
 ** ./src/components/Books/Add.js
 **/